import { useStrapiAuth } from "../composables/useStrapiAuth.mjs";
import { useStrapiUser } from "../composables/useStrapiUser.mjs";
import { defineNuxtPlugin } from "#imports";
export default defineNuxtPlugin(async () => {
  const user = useStrapiUser();
  if (!user.value) {
    const { fetchUser } = useStrapiAuth();
    await fetchUser();
  }
});
